/**
 * Family-local helpers of the ombyggnad / besittningsskydd / andrahand
 * families (meddelande_18e, godkannande_18d, avstaende_besittningsskydd_*,
 * ansokan_andrahand, evakuering). Everything generic — slots, autofill,
 * options, values, label/value rows, signing — comes from `../common`.
 */
import { p, t } from '@hyranai/regta-document-ir';
import { dateVal, signingBlockDefinition, textVal } from '../common/index.js';
const room = (code, value, summary) => ({ code, value, label: value, summary });
/** The legacy "Antal rum och kök" codebook; legacy contracts store the `value`. */
export const ROOM_OPTIONS = [
    room('r1_kokskap', '1 rum och kokskåp', '1 room with a kitchenette cupboard.'),
    room('r1_kokvra', '1 rum och kokvrå', '1 room with a kitchen nook.'),
    room('r1_kok', '1 rum och kök', '1 room with a full kitchen.'),
    room('r1_5_kok', '1,5 rum och kök', '1.5 rooms with a full kitchen.'),
    room('r2_kokvra', '2 rum och kokvrå', '2 rooms with a kitchen nook.'),
    room('r2_kok', '2 rum och kök', '2 rooms with a full kitchen.'),
    room('r2_5_kok', '2,5 rum och kök', '2.5 rooms with a full kitchen.'),
    room('r3_kok', '3 rum och kök', '3 rooms with a full kitchen.'),
    room('r3_5_kok', '3,5 rum och kök', '3.5 rooms with a full kitchen.'),
    room('r4_kok', '4 rum och kök', '4 rooms with a full kitchen.'),
    room('r4_5_kok', '4,5 rum och kök', '4.5 rooms with a full kitchen.'),
    room('r5_kok', '5 rum och kök', '5 rooms with a full kitchen.'),
    room('r6_kok', '6 rum och kök', '6 rooms with a full kitchen.'),
    room('r7_kok', '7 rum och kök', '7 rooms with a full kitchen.'),
    room('r8_kok', '8 rum och kök', '8 rooms with a full kitchen.'),
];
/** A boolean slot answer (legacy checkboxes may arrive as the string "true"). */
export const flag = (input, key) => input[key] === true || input[key] === 'true';
/** A free-text answer printed on its own ruled line(s). */
export const answer = (input, key) => p([textVal(input, key, 'full')]);
/** "<ort> den <datum>" — the place/date line above a signature block. */
export const placeDateLine = (input, ctx) => [
    p([textVal(input, 'signing_city'), t(' den '), dateVal(ctx, input, 'signing_date')]),
];
export const SIGNING_PLACE_DATE_SLOTS = [
    { key: 'signing_city', label: 'Ort', type: 'text', required: true, help: 'T.ex. Stockholm' },
    { key: 'signing_date', label: 'Datum', type: 'date', required: true },
];
export const legalMeta = (source) => ({
    plane: 'legal',
    status: 'published',
    language: 'sv-SE',
    legalReview: { reviewedBy: 'Haymanot', source },
});
/**
 * The shared signing block under a family block key, kept on the family's
 * legal plane (its statement wording is legal text).
 */
export const legalSigningBlock = (legal, spec) => ({
    ...signingBlockDefinition(spec),
    ...legal,
});
//# sourceMappingURL=kit.js.map